import barba from '@barba/core';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.pictureScroll()
            this.findUsScroll()
            this.cultureScroll()
            this.introduceScroll()
        });
        barba.hooks.after((data) => {
            this.pictureScroll()
            this.findUsScroll()
            this.cultureScroll()
            this.introduceScroll()
        });

    }
    pictureScroll(){
        this.trigger = document.querySelector('.js-scrollTrigger__picture');
        this.elem = document.querySelectorAll('.js-scrollElem__picture');
        if(this.elem) {
            this.elem.forEach((el, i) => {
                gsap.to(el, {
                    x: '17.5vw',
                    scrollTrigger: {
                      trigger: this.trigger,
                      start: 'top center' ,
                      end: '+150% center',  
                      scrub: 1, 
                    }
                });
            })
        }
    }
    findUsScroll(){
        this.trigger = document.querySelector('.js-scrollTrigger__findus');
        this.elem = document.querySelectorAll('.js-scrollElem__findus');
        if(this.elem) {
            this.elem.forEach((el, i) => {
                gsap.to(el, {
                    x: '-11.5vw',
                    scrollTrigger: {
                      trigger: this.trigger,
                      start: '-50% center' ,
                      end: '+150% center',
                      scrub: 1, 
                    }
                });
            })
        }
    }
    cultureScroll(){
        this.trigger = document.querySelector('.js-scrollTrigger__culture');
        this.elem = document.querySelectorAll('.js-scrollElem__culture');
        if(this.elem) {
            this.elem.forEach((el, i) => {
                gsap.to(el, {
                    x: '-33.3333vw',
                    scrollTrigger: {
                      trigger: this.trigger,
                      start: '-50% center' ,
                      end: '+150% center', 
                      scrub: 1, 
                    }
                });
            })
        }
    }
    introduceScroll(){
        this.trigger = document.querySelector('.js-scrollTrigger__introduce');
        this.elemRight = document.querySelectorAll('.js-scrollElem__introduce.-right');
        this.elemLeft = document.querySelectorAll('.js-scrollElem__introduce.-left');
        if(this.elemRight) {
            this.elemRight.forEach((el, i) => {
                gsap.to(el, {
                    y: -300,
                    scrollTrigger: {
                      trigger: this.trigger,
                      start: '-50% center' ,
                      end: '+150% center', 
                      scrub: 1, 
                    },
                    rotation: 90,
                });
            })
        }
        if(this.elemLeft) {
            this.elemLeft.forEach((el, i) => {
                gsap.to(el, {
                    y: 300,
                    scrollTrigger: {
                      trigger: this.trigger,
                      start: '-50% center' ,
                      end: '+150% center', 
                      scrub: 1, 
                    },
                    rotation: -90,
                });
            })
        }
    }
}